import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import classnames from 'classnames';

import '../../assets/css/header.css';
import RightMenuList from './RightMenuList';
import UseWindowSize from '../../hooks/UseWindowSize';
import appIcon from '../../assets/images/app-icon.png';
import { AppHeaderStates } from '../../common/types';

const { Paragraph } = Typography;

const location = '#1212, park square, Manson';
const Header1Content: React.FC<AppHeaderStates> = (Props) => {
  const size = UseWindowSize() || {};
  // @ts-ignore
  const { width } = size || {};

  return (
    <>
      <div className="left-menu">
        <div className="logo">
          <Link to="/home">
            <img src={appIcon} alt="Icon" />
          </Link>
        </div>
        <div className="select-location">
          <Button
            className={classnames('link-action-btn')}
            onClick={Props.onOpenLocation}
          >
            <Paragraph type="warning" strong={true}>
              {location}
              <DownOutlined style={{ paddingLeft: 10 }} />
            </Paragraph>
          </Button>
        </div>
      </div>
      {
        // @ts-ignore
        width > 900 && <RightMenuList />
      }
    </>
  );
};

export default Header1Content;
